module.exports = __webpack_public_path__ + "b3ef147db1baa25c971d3c7e3ec7beb2.MP3";